module.exports = __webpack_public_path__ + "static/img/son5.54fdd94f.png";